export default __webpack_public_path__ + "static/media/lucio-intro.98585741.mp3";